<template>
  <div class="student-detail-card" style="padding: 0 16px 16px !important;">
    <v-tabs v-model="tabSpecial">
      <v-tab v-show="isShowSpecialCareDetail">Chăm sóc đặc biệt</v-tab>
      <v-tab>Sự kiện nổi bật</v-tab>
      <v-tab-item v-show="isShowSpecialCareDetail">
        <SpecialCareDetailTable :item="studentBlendedTutorDetail" @show-detail="handleShowDetailSpecialCare"></SpecialCareDetailTable>
      </v-tab-item>
      <v-tab-item>
        <div v-if="highlights.length > 0" >
          <div id="style-2" style="max-height: 320px; overflow: auto">
            <div class="d-flex align-center" :class="highlights && highlights.length > 1 ? 'mb-4': ''" v-for="item in highlights" :key="item.id">
              <div class="highlight-box" :style="`border-left: 4px solid ${getColorByHighlightType(item.highlight_type).border}; background: ${getColorByHighlightType(item.highlight_type).background}`">
                <div class="d-flex">
                  <div class="mr-3 highlight-type text-no-wrap" :style="`color: ${getColorByHighlightType(item.highlight_type).color}`">
                    {{MAP_NOTIFICATION[item.type].text}}
                  </div>
                  <div v-html="item.content">
                  </div>
                  <span v-if="[HIGHLIGHT_TYPE.STUDENT_OFF_TICKET, HIGHLIGHT_TYPE.RESERVE].includes(item.highlight_type) && !checkHighlightText(item.content)" class="ml-2" style="color: #0180C7;text-decoration-line: underline;cursor: pointer;" @click="showNotivation(item)">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <img v-on="on" v-bind="attrs" src="../assets/detail-highlight-icon.svg" height="14" width="14" alt="" class="ml-2">
                </template>
                <span>Xem chi tiết</span>
              </v-tooltip>
            </span>
                </div>
                <div class="d-flex mt-2">
                  <div class="program-name" :style="`color: ${getColorByHighlightType(item.highlight_type).color}`">
                    {{item.product}}
                    <div class="ml-1" v-if="item.curriculum_id && mapProgramIdAndProgram[item.curriculum_id]">
                      - {{ mapProgramIdAndProgram[item.curriculum_id].title}}
                    </div>
                    <div class="ml-1" v-else-if="item.subject_id">
                      - {{ getSubjectById(item.subject_id).name}}
                    </div>
                  </div>
                  <div class="ml-3 mr-3">
                    <v-icon :color="`${getColorByHighlightType(item.highlight_type).color}`">mdi-circle-small</v-icon>
                  </div>
                  <div style="font-size: 12px">
                    {{moment(item.created_at).format('DD/MM/YYYY HH:mm')}}
                  </div>
                </div>
              </div>
              <!--        <img src="../../../assets/fi_star.svg" height="24" width="24" alt="">-->
              <!--        <div class="time-box text-no-wrap">-->
              <!--          {{moment(item.created_at).format('DD/MM/YYYY HH:mm')}}-->
              <!--        </div>-->
              <!--        <div-->
              <!--          :style="`background-color: ${TYPE_CURRICULUM_TAG[item.product.toLowerCase()] ? TYPE_CURRICULUM_TAG[item.product.toLowerCase()].color : '#000000'};`"-->
              <!--          class="subject-box tutor text-no-wrap">-->
              <!--          {{item.product}}-->
              <!--          <span v-if="item.curriculum_id && mapProgramIdAndProgram[item.curriculum_id]"> - {{mapProgramIdAndProgram[item.curriculum_id].title}}</span>-->
              <!--        </div>-->
              <!--        <div style="font-size: 13px">-->
              <!--          <span-->
              <!--            :style="`color: ${MAP_NOTIFICATION[item.type].color}`"-->
              <!--            style="font-weight: bold">{{MAP_NOTIFICATION[item.type].text}}:</span>-->
              <!--          {{item.content}}-->
              <!--        </div>-->
            </div>

          </div>
        </div>
        <div v-else style="max-height: 180px" class="d-flex align-center justify-center" :class="windowWidth > 1500 ? 'flex-column': ''">
          Học viên chưa có thông báo highlight của học viên
          <img src="../assets/no-highlight.svg" :height="windowWidth > 1500 ? 64 : 32" :width="windowWidth > 1500 ? 64 : 32" alt="" class="mb-2 ml-2 mt-1">
        </div>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-if="showpopup" v-model="showpopup" width="375">
      <popup-detail-noti v-if="dataShowPopup" :product="dataShowPopup.product" :soticketid="dataShowPopup.so_ticket_id" :typePopup="dataShowPopup.highlight_type" :classname="mapProgramIdAndProgram[dataShowPopup.curriculum_id].title" @close="closePopup()"></popup-detail-noti>
    </v-dialog>
  </div>
</template>

<script>
import mapSubject from '@/mixins/mapSubject';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import { MAP_NOTIFICATION, HIGHLIGHT_TYPE } from '@/modules/student_detail_bt/const';
import { TYPE_CURRICULUM_TAG } from '@/helpers/constant';
import SpecialCareDetailTable from '@/modules/student_care/components/SpecialCareDetailTable.vue';
import PopupDetailNoti from './PopupDetailNoti.vue';

export default {
  components: { PopupDetailNoti, SpecialCareDetailTable },
  name: 'StudentHistoryCard',
  mixins: [mapSubject],
  data() {
    return {
      tabSpecial: 0,
      highlights: [],
      moment,
      MAP_NOTIFICATION,
      TYPE_CURRICULUM_TAG,
      HIGHLIGHT_TYPE,
      windowWidth: window.innerWidth,
      showpopup: false,
      dataShowPopup: null,
    };
  },
  computed: {
    ...mapState('student_detail_bt', ['studentBlendedTutorDetail', 'filterForm']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    isShowSpecialCareDetail() {
      return !(_.get(this.studentBlendedTutorDetail, 'cancel_lesson', null) === null
        && _.get(this.studentBlendedTutorDetail, 'no_adtention', null) === null
        && _.get(this.studentBlendedTutorDetail, 'late', null) === null
        && _.get(this.studentBlendedTutorDetail, 'no_homework', null) === null
        && _.get(this.studentBlendedTutorDetail, 'test', []).length === 0
        && _.get(this.studentBlendedTutorDetail, 'change_teacher.data', []).length === 0
        && _.get(this.studentBlendedTutorDetail, 'date_next_test', null) === null);
    },
  },
  created() {
    this.getStudentHighlight();
    if (!this.isShowSpecialCareDetail) {
      this.tabSpecial = 1;
    }
  },
  watch: {
    'filterForm.dateTime': {
      deep: true,
      handler() {
        this.getStudentHighlight();
      },
    },
    showpopup(val) {
      if (!val) {
        this.dataShowPopup = null;
      }
    },
  },
  methods: {
    handleShowDetailSpecialCare() {
      this.$emit('show-detail-special-care');
    },
    checkHighlightText(text) {
      return text.includes('đã được hủy');
    },
    getColorByHighlightType(highlightType) {
      if (highlightType === HIGHLIGHT_TYPE.TUTOR_STUDY_NOT_JOIN || highlightType === HIGHLIGHT_TYPE.DUO_STUDY_NOT_JOIN) {
        return {
          border: '#E81E2F',
          color: '#F85866',
          background: '#FFF5F8',
        };
      } if (highlightType === HIGHLIGHT_TYPE.TUTOR_STUDY_LATE || highlightType === HIGHLIGHT_TYPE.TUTOR_STUDY_EARLY_LEAVE || highlightType === HIGHLIGHT_TYPE.DUO_STUDY_EARLY_LEAVE || highlightType === HIGHLIGHT_TYPE.DUO_STUDY_LATE) {
        return {
          border: '#FCA67C',
          color: '#FB8D57',
          background: '#FFF5ED',
        };
      }
      return {
        border: '#979799',
        color: '#707075',
        background: '#F5F4FC',
      };
    },
    async getStudentHighlight() {
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        const result = await BlendedCareRepository.getStudentHighlight({
          reportStartDate: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD 00:00:00'),
          reportEndDate: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD 00:00:00'),
          isHighlight: 1,
          lmsCoreUserId: this.studentBlendedTutorDetail.lms_core_user_id,
          // lmsCoreUserId: 10344,
        });
        if (result.message === 'Success') {
          this.highlights = result.data;
        }
      }
    },
    showNotivation(item) {
      const routeData = `${process.env.VUE_APP_ERP}/tutor/ticket?id=${item.so_ticket_id}&studentId=${item.student_id}`;
      window.open(routeData, '_blank');
    },
    closePopup() {
      this.showpopup = false;
      this.dataShowPopup = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.student-detail-card {
  background: white;
  border-radius: 12px;
  width: 98%;
  padding: 16px;
  margin-top: 15px;
}
.time-box {
  background: #F6F7F9;
  border-radius: 5px;
  padding: 4px 10px;
  margin-left: 10px;
  color: #52526C;
  font-size: 14px;
  font-weight: bold;
}
.subject-box {
  border-radius: 4px;
  padding: 4px 5px;
  color: white;
  font-size: 12px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 20px;
}
.subject-box.tutor {
  background: #AB47BC;
}
.subject-box.duo {
  background: #0180C7;
}
@media screen and (max-width: 1440px) {
 .custome-w {
   width: 100%;
 }
 .student-detail-card {
  font-size: 12px !important;
  .time-box {
    font-size: 12px !important;
    width: 128px;
  }
 }
}
.highlight-box {
  border-left: 4px solid red;
  padding: 6px 16px 0px 16px;
  background: #FFF5F8;
  width: fit-content;
  border-radius: 0 5px 5px 0;
}
.highlight-type {
  font-weight: bold;
  font-size: 14px;
}
.program-name {
  display: flex;
  font-size: 12px;
  font-weight: bold;
}
</style>
